import { render, staticRenderFns } from "./FormQuestion.vue?vue&type=template&id=79974b74&scoped=true&"
import script from "./FormQuestion.vue?vue&type=script&lang=js&"
export * from "./FormQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FormQuestion.vue?vue&type=style&index=0&id=79974b74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79974b74",
  null
  
)

export default component.exports